import React, { useState } from 'react';
import './TakvimSection.css';

const TakvimSection = () => {
  // Örnek veriler (Mart 2025)
  // Aynı günlere (ör. 2025-03-02, 2025-03-10) birden fazla kayıt ekledim.
  const events = [
    { date: '2025-03-01', title: 'Avans Talebi', description: '1500 TL (Beklemede)' },

    { date: '2025-03-02', title: 'Zimmet Talebi', description: 'Laptop Talebi (Onay Bekliyor)' },
    { date: '2025-03-02', title: 'İzin Talebi', description: '1 Gün İzin (20.03.2025)' },

    { date: '2025-03-05', title: 'Zimmet Talebi', description: 'Projeksiyon' },

    { date: '2025-03-10', title: 'Etkinlik', description: 'Takım Yemeği (15.04.2025)' },
    { date: '2025-03-10', title: 'Avans Talebi', description: '3000 TL (Beklemede)' },
    { date: '2025-03-10', title: 'Toplantı', description: 'Proje Durum Değerlendirmesi' },

    { date: '2025-03-12', title: 'Avans Talebi', description: '1000 TL (Onaylandı)' },

    { date: '2025-03-15', title: 'İK Duyurusu', description: 'Performans Değerlendirmesi 2025' },
    { date: '2025-03-15', title: 'Zimmet Talebi', description: 'Monitör' },

    { date: '2025-03-20', title: 'İK Duyurusu', description: 'Online Eğitim Programı' },

    { date: '2025-03-25', title: 'Toplantı', description: 'Yeni Proje Kickoff' },

    { date: '2025-03-27', title: 'Avans Talebi', description: '2000 TL (Reddedildi)' },
  ];

  // Modal için state
  const [showModal, setShowModal] = useState(false);
  const [selectedEvents, setSelectedEvents] = useState([]);

  // Mart 2025 => 31 gün
  const daysInMonth = 31;
  // 1 Mart 2025 Cumartesi => offset=5 (haftayı Pzt=0 baz alırsak)
  const startDayOffset = 5;

  // Haftanın günleri (Pzt ile başlayacak)
  const daysOfWeek = ['Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt', 'Paz'];

  // Güne tıklandığında modal açma
  const handleDayClick = (dayNumber) => {
    const dayStr = dayNumber < 10 ? `0${dayNumber}` : dayNumber;
    const dateStr = `2025-03-${dayStr}`;

    // O güne ait kayıtları bul
    const dayEvents = events.filter((evt) => evt.date === dateStr);
    if (dayEvents.length > 0) {
      setSelectedEvents(dayEvents);
      setShowModal(true);
    } else {
      setSelectedEvents([]);
      setShowModal(false);
    }
  };

  // Modal'ı kapat
  const closeModal = () => {
    setShowModal(false);
    setSelectedEvents([]);
  };

  // Takvim hücrelerini oluşturma (6 hafta x 7 gün = 42 hücre)
  const totalCells = 42;
  let cells = [];

  for (let i = 0; i < totalCells; i++) {
    // dayNumber = i - offset + 1
    const dayNumber = i - startDayOffset + 1;

    if (dayNumber < 1 || dayNumber > daysInMonth) {
      // Ay dışındaki hücreler
      cells.push(
        <td key={i} className="empty-cell"></td>
      );
    } else {
      // Bu güne ait eventleri bul
      const dayStr = dayNumber < 10 ? `0${dayNumber}` : dayNumber;
      const dateStr = `2025-03-${dayStr}`;
      const dayEvents = events.filter((evt) => evt.date === dateStr);

      cells.push(
        <td
          key={i}
          className={`day-cell ${dayEvents.length > 0 ? 'has-event' : ''}`}
          onClick={() => handleDayClick(dayNumber)}
        >
          <div className="day-number">{dayNumber}</div>
          {/* Her event için bir badge */}
          {dayEvents.map((evt, idx) => (
            <div key={idx} className="event-badge">
              {evt.title}
            </div>
          ))}
        </td>
      );
    }
  }

  // 6 satır oluştur (her satır 7 hücre)
  let rows = [];
  for (let r = 0; r < 6; r++) {
    const rowCells = cells.slice(r * 7, r * 7 + 7);
    rows.push(<tr key={r}>{rowCells}</tr>);
  }

  return (
    <div className="takvim-container">
      <h2>Takvim - Mart 2025</h2>
      <p className="takvim-subtitle">
        Avans, zimmet, etkinlik, izin ve diğer kayıtlarınızın özet görünümü.
      </p>

      <table className="calendar-table">
        <thead>
          <tr>
            {daysOfWeek.map((day, i) => (
              <th key={i}>{day}</th>
            ))}
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </table>

      {/* Modal (Pop-up) */}
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Gün Detayları</h3>
            {selectedEvents.map((evt, index) => (
              <div key={index} className="modal-event-item">
                <h4>{evt.title}</h4>
                <p>{evt.description}</p>
              </div>
            ))}
            <button className="modal-close" onClick={closeModal}>
              x
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TakvimSection;
